/**
 * @generated SignedSource<<1a571eeab6b2fde99321fa42ef724287>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteTimeSelectorModal_note$data = {
  readonly createdAt: string | null;
  readonly eventEnd: string | null;
  readonly eventStart: string | null;
  readonly id: string;
  readonly " $fragmentType": "NoteTimeSelectorModal_note";
};
export type NoteTimeSelectorModal_note$key = {
  readonly " $data"?: NoteTimeSelectorModal_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteTimeSelectorModal_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteTimeSelectorModal_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "6cb9ec3dcdb7d15efa46111be60462ee";

export default node;
